import axios from "../axios";
import AxiosConfig from "../AxiosConfig";

/**
 *
 * @param id
 * @returns {function(*): Promise<AxiosResponse<T> | never>}
 */
export const fetchComments = (id, order = "newest") => {

  return dispatch => {

    dispatch({type: "COMMENTS_FETCH"});

    const url = AxiosConfig.getEndpointAddress() + "/comments/" + id + "?" + AxiosConfig.objectToURLQuery({
      order
    });

    return axios.get(
      url,
      AxiosConfig.getAuthConfig()
    )
      .then((response) => {

        dispatch({
          type: "COMMENTS_FETCH_FULFILLED",
          data: response.data,
        });

      })
      .catch(function (error) {

        dispatch({
          type: "COMMENTS_FETCH_REJECTED",
          data: error,
        });

      });
  };
};
